import React, { Fragment } from "react";
import authApi from "../../../utils/api/authApi";
import { Stack, Button, Paper, TextField, Alert } from "@mui/material";
import PageContentWrapper from "../../../components/wrappers/PageContentWrapper";
import CenterScreen from "../../../components/wrappers/CenterScreen";
import * as IoIcons from "react-icons/io";
import { LOGIN } from "../../../enums/UrlPaths";
import { FORGOTTEN_PASSWORD } from "../../../enums/ApiPaths";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { HttpStatusCode } from "axios";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../../utils/Functions";
import { snackbarSeverity } from "../../../hooks/useSnackbar";
import { SnackbarContext } from "../../../contexts/Snackbar";
import AuthFooter from "../login/component/AuthFooter";
export default function ForgottenPasswordPage() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [showGoBackButton, setShowGoBackButton] = React.useState(false);
  const { register, handleSubmit } = useForm();

  const forgottenPasswordSubmit = async (e) => {
    if (e?.email != "") {
      try {
        let res = await authApi.post(FORGOTTEN_PASSWORD + "?email=" + e.email);

        if (res.status == HttpStatusCode.Ok) {
          handleSnackbar("PasswordResetSent", snackbarSeverity.SUCCESS);
          setShowGoBackButton(true);
        }
      } catch (error) {
        handleSnackbar(error?.response?.data, snackbarSeverity.ERROR);
        setShowGoBackButton(false);
      }
    } else {
      handleSnackbar("EnterDataToSubmitForm", snackbarSeverity.INFO);
      setShowGoBackButton(false);
    }
  };
  const mobile = useIsMobile();

  return (
    <Fragment>
      <CenterScreen minHeight="78vh">
        <form onSubmit={handleSubmit(forgottenPasswordSubmit)}>
          <Stack spacing={3} width={{ xs: "90vw", sm: "70vw", md: "30vw" }}>
            <Alert severity="info">
              {t("ForgottenPasswordUserDisplayMessage")}
            </Alert>
            <TextField
              sx={{ width: "100%", m: 2 }}
              inputProps={{ maxLength: 255 }}
              label={t("Email")}
              {...register("email")}
            />
            <Stack spacing={1}>
              <Button type="submit" variant="contained" color="primary">
                {t("Send")}
              </Button>
              <Button
                onClick={() => navigate(LOGIN)}
                variant={showGoBackButton ? "contained" : "outlined"}
                color={showGoBackButton ? "primary" : "primary"}
              >
                {t("GoBack")}
              </Button>
            </Stack>
          </Stack>
        </form>
      </CenterScreen>
      <AuthFooter />
    </Fragment>
  );
}
